import { render, staticRenderFns } from "./x-message-dialog.vue?vue&type=template&id=24d6f1e7"
import script from "./x-message-dialog.vue?vue&type=script&lang=js"
export * from "./x-message-dialog.vue?vue&type=script&lang=js"
import style0 from "./x-message-dialog.vue?vue&type=style&index=0&id=24d6f1e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports